import { Sparkles, Brain, Cpu } from 'lucide-react';
import WaveAnimation from '../components/WaveAnimation';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-gray-900 pt-24 relative overflow-hidden">
      <WaveAnimation />
      
      <div className="container mx-auto px-4 py-12 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-2 mb-4">
              <Sparkles className="text-purple-400 w-6 h-6" />
              <span className="text-purple-400">About Us</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Revolutionizing Tech Education
            </h1>
            <p className="text-xl text-gray-300">
              We're on a mission to transform how people learn technology through 
              AI-powered personalized education.
            </p>
          </div>

          <div className="space-y-16">
            <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-8">
              <div className="flex items-start gap-6">
                <Brain className="w-12 h-12 text-purple-400 flex-shrink-0" />
                <div>
                  <h2 className="text-2xl font-bold text-white mb-4">Our Vision</h2>
                  <p className="text-gray-300 leading-relaxed">
                    We envision a world where quality tech education is accessible to everyone, 
                    regardless of their background or location. Through our AI-powered platform, 
                    we're making this vision a reality by providing personalized learning experiences 
                    that adapt to each student's unique needs and pace.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-8">
              <div className="flex items-start gap-6">
                <Cpu className="w-12 h-12 text-purple-400 flex-shrink-0" />
                <div>
                  <h2 className="text-2xl font-bold text-white mb-4">Our Technology: AI-Powered Learning Redefined</h2>
                  <p className="text-gray-300 leading-relaxed mb-6">
                    Experience the future of education with our advanced AI technology, designed to provide 
                    immersive chat and voice-based interactions within each course module. Every course is 
                    equipped with AI models trained on its specific content, ensuring accurate and personalized 
                    assistance.
                  </p>
                  <ul className="space-y-4">
                    <li className="flex items-start gap-3">
                      <span className="w-2 h-2 bg-purple-400 rounded-full mt-2"></span>
                      <span className="text-gray-300">
                        <span className="text-white font-semibold">AI-Driven Course Modules:</span> Each course 
                        is powered by dedicated AI trained on its unique content for highly relevant and precise 
                        interactions.
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-2 h-2 bg-purple-400 rounded-full mt-2"></span>
                      <span className="text-gray-300">
                        <span className="text-white font-semibold">Adaptive Learning Algorithms:</span> Our system 
                        understands your style, pace, and preferences, tailoring your learning journey in real time.
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-2 h-2 bg-purple-400 rounded-full mt-2"></span>
                      <span className="text-gray-300">
                        <span className="text-white font-semibold">Interactive Chat & Voice-Based Support:</span> Engage 
                        with AI through seamless chat and voice interactions, making learning more dynamic and engaging.
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-2 h-2 bg-purple-400 rounded-full mt-2"></span>
                      <span className="text-gray-300">
                        <span className="text-white font-semibold">Real-Time Progress Tracking:</span> Monitor your 
                        achievements and growth with detailed progress updates.
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-2 h-2 bg-purple-400 rounded-full mt-2"></span>
                      <span className="text-gray-300">
                        <span className="text-white font-semibold">Personalized Content Delivery:</span> Receive 
                        customized guidance and solutions, empowering you to master any subject with ease.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-8">
              <h2 className="text-2xl font-bold text-white mb-6">Our Impact</h2>
              <div className="grid md:grid-cols-4 gap-8">
                <div className="text-center">
                  <div className="text-4xl font-bold text-purple-400 mb-2">3+</div>
                  <div className="text-gray-300">Interactive Courses</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold text-purple-400 mb-2">1,000+</div>
                  <div className="text-gray-300">Active Learners</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold text-purple-400 mb-2">98%</div>
                  <div className="text-gray-300">Satisfaction Rate</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold text-purple-400 mb-2">60%</div>
                  <div className="text-gray-300">Faster Completion Rates</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}